<template>
    <div class="client-edit">
        <template v-if="isBusy">
            <Preloader/>
        </template>
        <template v-else>
            <form name="client_edit" @submit.prevent="updateClient">
                <div class="row">
                    <div class="col-12">
                        <div class="form_ttl_first">Modifier les Infos clients</div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label">Civilit&eacute;</div>
                            <div class="form__item__input-wrapper">
<!--                                <select name="civilite" id="civilite" class="select_civ" v-model="client.civility">-->
<!--                                    <option value="0">M</option>-->
<!--                                    <option value="1">Mlle</option>-->
<!--                                    <option value="2">Mme</option>-->
<!--                                </select>-->
                                <div>{{$root.parseValue(client.civility, CLIENT_CIVILITY)}}</div>
<!--                                {{parseValue(insurance.details.garantie, INSURANCE_AUTO)}}-->
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Nom</div>
                            <div class="form__item__input-wrapper">
<!--                                <input type="text" v-model="client.last_name" name="nom" id="nom" class="input_n"/>-->
                                <div>{{client.last_name}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Pr&eacute;nom</div>
                            <div class="form__item__input-wrapper">
<!--                                <input type="text" v-model="client.first_name" name="prenom" id="prenom"-->
<!--                                       class="input_n"/>-->
                                <div>{{client.first_name}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label">Adresse</div>
                            <div class="form__item__input-wrapper">
<!--                                <input type="text" v-model="client.address" name="adresse" id="adresse"-->
<!--                                       class="input_n"/>-->
                                <div>{{client.address}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label">Code postal</div>
                            <div class="form__item__input-wrapper">
<!--                                <input type="text" v-model="client.zip" name="cp" id="cp" maxlength="5"-->
<!--                                       class="input_n"/>-->
                                <div>{{client.zip}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label">Ville</div>
                            <div class="form__item__input-wrapper">
<!--                                <input type="text" v-model="client.city" name="ville" id="ville" class="input_n"/>-->
                                <div>{{client.city}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label">T&eacute;l&eacute;phone</div>
                            <div class="form__item__input-wrapper">
<!--                                <input type="text" v-model="client.tel" name="tel" id="tel" maxlength="10"-->
<!--                                       class="input_n"/>-->
                                <div>{{client.tel}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label">Fax</div>
                            <div class="form__item__input-wrapper">
<!--                                <input type="text" v-model="client.fax" name="fax" id="fax" maxlength="10"-->
<!--                                       class="input_n"/>-->
                                <div>{{client.fax}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item">
                            <div class="form__item__label form__item__label--required">Email</div>
                            <div class="form__item__input-wrapper">
<!--                                <input type="text" v-model="client.email" name="email" id="email" class="input_n"/>-->
                                <div>{{client.email}}</div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12">
                        <div class="form__item justify-content-center mt-3 mb-3">
                            <div class="form__item__submit">
                                <input @click.stop.prevent="handleSubmit"
                                    type='submit' value="Retour" class="form_bt form_confirm_button form__item__submit__button"/>
                            </div>
                        </div>
                    </div>
                </div>
                <ValidationErrors :errorsList="errors"/>
            </form>
        </template>
    </div>
</template>

<script>
    import garantieFieldsLists from '../../mixins/garantieFieldsLists';
    import ValidationErrors from '@/components/Garantie/ValidationErrors';
    import {CLIENT_CIVILITY} from "../../constants/client";

    export default {
        name: 'ClientEdit',
        mixins: [garantieFieldsLists],
        components: {ValidationErrors},
        data() {
            return {
                client: {
                    address: '',
                    birthday: '',
                    city: '',
                    civility: 0,
                    email: "alexey@netgow.com",
                    family: null,
                    fax: null,
                    first_name: "qew",
                    last_name: "qew",
                    profession: null,
                    tel: "123",
                },
                errors: {},
                isBusy: false,
                CLIENT_CIVILITY,
            }
        },
        computed: {
            client_id() {
                return this.$route.params.id;
            }
        },
        methods: {
            returnToClientsTable() {
                this.$router.push('/clients');
            },
            getClientInfo() {
                this.isBusy = true;
                let url = 'client/' + this.client_id;
                this.apiGet(url)
                    .then(response => {
                        this.client = response.data.client;
                        this.isBusy = false;
                    })
                    .catch(error => {
                        this.isBusy = false;
                        this.showErrorNotification(error);
                    })
            },
            updateClient() {
                this.isBusy = true;
                let url = 'client/update/' + this.client_id,
                    data = {...this.serializeData()};
                this.errors = {};
                this.apiPost(url, data)
                    .then(response => {
                        this.showSuccessNotification('Modifié avec succès', '');
                        this.isBusy = false;
                        this.returnToClientsTable();
                    })
                    .catch(error => {
                        this.errors = error.response.data;
                        this.isBusy = false;
                    })
            },
            serializeData() {
                return this.client;
            },
            handleSubmit() {
                this.$router.push('/clients');
            },
        },
        mounted() {
            this.getClientInfo();
            this.$eventBus.$emit('sidebar-set-active-tab', 'Clients');
        },
        beforeDestroy() {
            this.$eventBus.$emit('sidebar-set-active-tab', '');
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/Clients/EditClient.vue